import { StyleSheet, ViewProps } from 'react-native'
import { BreadcrumbData } from 'zens-storybook'
import { useBuilding } from 'zens-store'
import { useTranslation } from 'react-i18next'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
  buildingId?: number
  title?: string
  breadcrumbItems?: BreadcrumbData[]
}

const InsightsHeader = (props: Props) => {
  const { companyId, buildingId = 0, title, breadcrumbItems, style, ...otherProps } = props
  const building = useBuilding({ companyId, buildingId })
  const { t } = useTranslation()
  const breadcrumb = useBreadcrumb([
    {
      title: t('Insights'),
      href: `/companies/${companyId}/insights`,
    },
    {
      title: building.data?.name || '',
      href: `/companies/${companyId}/insights/${buildingId}`,
    },
    ...(breadcrumbItems || []),
  ])
  return (
    <LayoutHeader
      breadcrumb={breadcrumb}
      title={title || t('Insights')}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

export default InsightsHeader
